<template>
  <div>
    <Modal :footer-hide="scene != 'sceneGov'" :mask-closable="false" v-model="show" :title="row.name" :width="1000" @on-cancel="clearForm()">
      <span class="markerpen">
        <font v-if="row.govAuthStatus == 100" class="CL5">监管待审</font>
        <font v-if="row.govAuthStatus == 200" class="CL4">监管通过</font>
        <font v-if="row.govAuthStatus == 300" class="CL6">监管拒审</font>
      </span>
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th  colspan="10"></th>
        </tr>
        <tr>
          <td><b>排放单位</b></td>
          <td  colspan="10">{{ row.name }}</td>
        </tr>
        <tr>
          <td><b>通讯地址</b></td>
          <td  colspan="10">{{ row.addressFull }}</td>
        </tr>
        <tr>
          <td><b>联系姓名</b></td>
          <td  colspan="10">{{ row.contactName }}</td>
        </tr>
        <tr>
          <td><b>联系电话</b></td>
          <td  colspan="10">{{ row.contactTel }}</td>
        </tr>
        <tr>
          <td><b>监管状态</b></td>
          <td  colspan="10">
            <span>{{ $CVALUE("govAuthStatus", row.govAuthStatus) }}</span>
            <span class="ML5">{{ row.govAuthStatusNote || "" }}</span>
          </td>
        </tr>

        <!---排放资质-->
        <tr>
          <th>排放资质</th>
          <th style="text-align: right"  colspan="10">
            <span class="CL4" v-if="row.paifangAuth == 100"><i class="MR3 iconfont icon-tongyi"></i>排放权限已开通</span>
            <span class="CL1" v-if="row.paifangAuth == 200"><i class="MR3 iconfont icon-wenhao-quan"></i>排放权限已关闭</span>
            <span class="CL1" v-if="row.paifangAuth == 300"><i class="MR3 iconfont icon-wenhao-quan"></i>排放权限待提审</span>
            <span class="CL1" v-if="row.paifangAuth == 400"><i class="MR3 iconfont icon-wenhao-quan"></i>排放权限审核中</span>
            <span class="CL1" v-if="row.paifangAuth == 500"><i class="MR3 iconfont icon-wenhao-quan"></i>排放权限已拒绝</span>
          </th>
        </tr>
        <tr v-for="(item, index) in row.orgAllQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td colspan="10">
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="$isblank(row.orgAllQualification)">
          <td style="text-align: center" colspan="10">暂未完善相关资质</td>
        </tr>
        <!---排放资质 end-->

          <!---相关联单-->
          <tr>
          <th colspan="10">相关工地（云开装船合计:{{ row.AllgarbageNumber }}m³ 已运总方合计:{{ row.AllpaifangGarbageNumberTotal }}m³ 已运船方:{{ row.AllpaifangGarbageCountTotal }}次 排放比例:{{ $percent(row.AllpaifangGarbageNumberTotal, row.AllgarbageNumber) }}%）</th>
        </tr>
        <tr v-if="!$isblank(row.orgprojectList)">
          <td>
            <b>工地编号</b>
          </td>
          <td>
            <b>工地名称</b>
          </td>
          <td width="8%">
            <b>云开装船</b>
          </td>
          <td width="8%">
            <b>已运船方</b>
          </td>
          <td width="8%">
            <b>已运次</b>
          </td>
          <td width="8%">
            <b>状态</b>
          </td>
          <td width="5%">
            <b>操作</b>
          </td>
          
        </tr>
        <tr v-for="(item, index) in row.orgprojectList" :key="index">
          <td width="18%">
            {{ item.NO}}
          </td>
          <td>
            {{ item.name }}➥{{ item.licensePlate }}
          </td>
          <td>
            {{ item.yunkaiGarbageNumberTotal }}m³
          </td>
          <td>
            {{ item.paifangGarbageNumberTotal }}m³
          </td>
          <td>
            {{ item.paifangGarbageCountTotal }}
          </td>
          <td>
            <Tag :color="$CVALUE('projectStatusTagColor', item.status)">{{ $CVALUE("projectStatus", item.status) }}</Tag>
          </td>
          <td width="5%">
            <Button type="warning" size="small" @click="$QHopen.url($httpServerH5('/electronicbilldetailed?NO=' + item.ENO), 750, 80)" style="margin-left: 5px">详情</Button>
          </td>
        </tr>
        <tr v-if="!$isblank(row.orgprojectList)">
          <td colspan="10" >
            <b @click="$goOrgPaifangProjectList(row)">查看全部</b>
          </td>
        </tr>
        <tr v-if="$isblank(row.orgprojectList)">
          <td style="text-align: center" colspan="10">暂无相关联单</td>
        </tr>
        <!---相关联单 end-->
 
        <!--审核日志-->
        <tr>
          <th>审核记录</th>
          <th colspan="10"></th>
        </tr>
        <tr v-if="$isblank(row.log)">
          <td colspan="10">暂无审核记录</td>
        </tr>
        <tr v-if="!$isblank(row.log)">
          <td colspan="10">
            <div style="text-align: left; padding: 5px; border-radius: 5px; margin: 5px 0; background: #f5f5f5" v-for="(item, index) in row.log" :key="index">
              <p>{{ $timeFmt(item.created, "YYYY年MM月DD日 HH:mm") }}➥行政单位:{{ item.orgName }}➥账号:{{ item.username }}➥通过:{{ item.app }}</p>
              <p>{{ item.content }}</p>
            </div>
          </td>
        </tr>
        <!---审核日志 end-->
        
      </table>

      <!---操作区域-->
      <div slot="footer">
        <Button type="success" v-if="scene == 'sceneGov'" @click="$refs.OSgovAuth.hiPop(row.id, 'govAuthPaifang')">监管审核</Button>
        <Button type="primary" @click="$goQiyeBigscreen(row.id, 3)">登录该企业大屏</Button>
      </div>
      <!---操作区域 end-->
    </Modal>

    <!--弹窗组件区-->
    <OSgovAuth ref="OSgovAuth" @success="reDetailed()"></OSgovAuth>
    <!--弹窗组件区 end-->
  </div>
</template>
<script>
import OSgovAuth from "@/component/OSgovAuth/OSgovAuth";
export default {
  components: {
    OSgovAuth,
  },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      show: false,
      isUpdate: false,
      row: {},
    };
  },
  props: {
    scene: {
      type: String,
      required: false,
      default: "sceneUsed",
    },
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgpaifangDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:刷新详情
    // +----------------------------------------------------------------------
    reDetailed() {
      this.hiPop(this.row);
      this.isUpdate = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理关闭
    // +----------------------------------------------------------------------
    clearForm() {
      this.show = false;
      this.row = {};
      if (this.isUpdate) {
        this.$emit("success");
        this.isUpdate = false;
      }
    },
  },
};
</script>
